module.exports = __webpack_public_path__ + "static/media/welcome_data_image.4a294556.jpg";